import userInformationTypes from './userInformationTypes'

export const getUserInformation = payload => ({
  type: userInformationTypes.GET_USER_INFORMATION,
  payload
})

export const getUserInformationSuccess = payload => ({
  type: userInformationTypes.GET_USER_INFORMATION_SUCCESS,
  payload
})

export const getUserInformationFailure = payload => ({
  type: userInformationTypes.GET_USER_INFORMATION_FAILURE,
  payload
})

export const clearUserInformation = () => ({
  type: userInformationTypes.CLEAR_USER_INFORMATION
})

export const updateUserInformation = payload => ({
  type: userInformationTypes.UPDATE_USER_INFORMATION,
  payload
})

export const updateUserInformationSuccess = payload => ({
  type: userInformationTypes.UPDATE_USER_INFORMATION_SUCCESS,
  payload
})

export const updateUserInformationFailure = payload => ({
  type: userInformationTypes.UPDATE_USER_INFORMATION_FAILURE,
  payload
})

export const updatePhotoUserInformation = payload => ({
  type: userInformationTypes.UPDATE_PHOTO_USER_INFORMATION,
  payload
})

export const updatePhotoUserInformationSuccess = payload => ({
  type: userInformationTypes.UPDATE_PHOTO_USER_INFORMATION_SUCCESS,
  payload
})

export const updatePhotoUserInformationFailure = payload => ({
  type: userInformationTypes.UPDATE_PHOTO_USER_INFORMATION_FAILURE,
  payload
})

export const changeEmailUserInformation = payload => ({
  type: userInformationTypes.CHANGE_EMAIL_USER_INFORMATION,
  payload
})

export const changeEmailUserInformationSuccess = payload => ({
  type: userInformationTypes.CHANGE_EMAIL_USER_INFORMATION_SUCCESS,
  payload
})

export const changeEmailUserInformationFailure = payload => ({
  type: userInformationTypes.CHANGE_EMAIL_USER_INFORMATION_FAILURE,
  payload
})
export const changePasswordUserInformation = (payload, callback) => ({
  type: userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION,
  payload,
  callback
})

export const changePasswordUserInformationSuccess = payload => ({
  type: userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION_SUCCESS,
  payload
})

export const changePasswordUserInformationFailure = payload => ({
  type: userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION_FAILURE,
  payload
})
